import { toReadablePrice } from "../../../../../lib/utils";
import DottedList from "../../../../ui/dottedList";
import styles from "./styles.module.scss";

interface IAboutApartment {
  roomCount?: number;
  areaInSqM?: number;
  floor?: number;
  bedroomCount?: number;
  combinedBathroomCount?: number;
  separateBathroomCount?: number;
  balconyCount?: number;
  loggiaCount?: number;
  currentPrice: number;
}

const AboutApartment = ({
  floor,
  bedroomCount,
  combinedBathroomCount,
  separateBathroomCount,
  balconyCount,
  loggiaCount,
  currentPrice,
}: IAboutApartment) => {

  const getBathroom = () => {
    if (combinedBathroomCount || separateBathroomCount) {
      return `${
        combinedBathroomCount ? `Cовмещ. ${combinedBathroomCount}` : ""
      }${combinedBathroomCount && separateBathroomCount ? " " : ""}${
        separateBathroomCount ? `Раздел. ${separateBathroomCount}` : ""
      }`;
    }
    return "Неизвестно";
  };

  return (
    <div className={styles.aboutApartment}>
      <div className={styles.aboutApartment__container}>
        <div className={styles.aboutApartment__title}>Квартира</div>
        <div className={styles.aboutApartment__price}>
          <DottedList
            items={[
              {
                label: "Цена",
                value: toReadablePrice(currentPrice) ?? "Неизвестно",
              },
            ]}
          />
        </div>
        <div className={styles.aboutApartment__floor}>
          <DottedList
            items={[{ label: "Этаж", value: floor ?? "Неизвестно" }]}
          />
        </div>

        <div className={styles.aboutApartment__bedRoomCount}>
          <DottedList
            items={[
              {
                label: "Количество спален",
                value: bedroomCount ?? "Неизвестно",
              },
            ]}
          />
        </div>

        <div className={styles.aboutApartment__bathRoomCount}>
          <DottedList
            items={[
              {
                label: "Санузел",
                value: getBathroom(),
              },
            ]}
          />
        </div>

        <div className={styles.aboutApartment__balcony}>
          <DottedList
            items={[
              {
                label: "Количество балконов",
                value: balconyCount ?? "Неизвестно",
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutApartment;
